// 获取内容接口
import request from './http'
// import {emptyToNull} from "@/utils";
// 免登录相关接口
export function loginNoRequired(data,flag){
  let param = data;
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/setLogin'
    return request(urlBase + urlPath, param, 'post', false);
  }else {
    // 内网
    // return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/setLogin' , param, 'post', false)
    return request('/pc-api/team/setLogin' , param, 'post', false)
  }
}
// 发验证码相关接口
export function getCode(data,flag) {
  let param = data;
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/codeSend'
    return request(urlBase + urlPath, param, 'post', false);
  }else {
    // 内网
    // return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/codeSend' , param, 'post', false)
    return request('/pc-api/team/codeSend' , param, 'post', false)
  }

}
// 校验验证码登录接口
export function toLoginByCode(data,flag) {
  let param = data;
  if (flag){
    // 线上
    let urlBase = 'https://d11-api.galasports.com/';
    let urlPath = flag + '/team/codeVerify'
    return request(urlBase + urlPath, param, 'post', false);
  }else {
    // 内网
    // return request('http://backend-shopping.test-galasports.com:8104/double11_pre_30/team/codeVerify' , param, 'post', false)
    return request('/pc-api/team/codeVerify' , param, 'post', false)
  }
}

// 拉全部球员信息
export function getPlayerAllInfos() {
  let param = {}
  // return request('/h5/player.json' , param, 'get', true)
  return request('https://tf.galasports.com/anniversaryreport/localJson/player.json ' , param, 'get', true)
  // return request('http://community-h5.test-galasports.com/anniversary/localJson/player.json ' , param, 'get', true)
}
// 拉多语言球员名
export function getPlayerNames() {
  let param = {}
  // 本地测试地址
  // return request('/h5/language.json' , param, 'get', true)
  return request('https://tf.galasports.com/anniversaryreport/localJson/language.json' , param, 'get', true)
  // 发内网地址
  // return request('http://community-h5.test-galasports.com/anniversary/localJson/language.json' , param, 'get', true)
}
